import { Box, Modal, styled } from "@mui/material";

export const Styled = {
    Modal: styled(Modal)`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
    Container: styled(Box)`
        background-color: white;
        padding: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        max-width: 90vw;
        max-height: 90vh;
    `,
    Content: styled(Box)`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};
